import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class BrandApiClient extends AdvancedApiClient {

    static entityType = "Brand"

    constructor(token, id) {
        super();

        this.setEntityType(BrandApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/brand/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/brand");
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}